// extracted by mini-css-extract-plugin
module.exports = {"skelton":"style_skelton__WIEmV","ionSlides":"style_ionSlides__3lnun","ionSlide":"style_ionSlide__2cG6B","videoOverlay":"style_videoOverlay__2lHUd","ionFab":"style_ionFab__DP-Ep"};